"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitersService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
var JSONbig = require('json-bigint')({ useNativeBigInt: true });
class WaitersService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    fetch(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}hotel_billing/waiter/list?outlet_id=${payload.outlet_id}&page=${payload.pageNumber}&limit=${payload.limit}`;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i].key = i;
                }
                const responseData = response.data.data;
                return responseData;
            }
            catch (error) {
                throw new Error("Failed to fetch waiters");
            }
        });
    }
    create(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}hotel_billing/waiter/create`;
                payload = JSONbig.stringify(payload);
                const response = yield axios_1.default.post(url, payload, {
                    headers: header
                });
                const responseData = response.data.message;
                return responseData;
            }
            catch (error) {
                throw new Error("Failed to create waiter");
            }
        });
    }
    update(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}hotel_billing/waiter/edit`;
                payload = JSONbig.stringify(payload);
                const response = yield axios_1.default.put(url, payload, {
                    headers: header
                });
                const responseData = response.data.message;
                return responseData;
            }
            catch (error) {
                throw new Error("Failed to update waiter");
            }
        });
    }
}
exports.WaitersService = WaitersService;
